import axios from "axios";
import { getBackendUrl } from "../../../utils/env";

const baseUrl = () => getBackendUrl().replace(/\/+$/, "");

const authHeaders = (token, extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${token}`,
});

export const getImageUrl = (path) =>
  path ? `${baseUrl()}/${String(path).replace(/^\/+/, "")}` : undefined;

export async function fetchStoreData(userId, token) {
  const config = { headers: authHeaders(token) };

  const [productsRes, pointsRes] = await Promise.all([
    axios.get(`${baseUrl()}/api/store/products.php`, config),
    axios.get(`${baseUrl()}/api/user-points.php`, {
      ...config,
      params: { user_id: userId },
    }),
  ]);

  if (!productsRes.data.success) {
    throw new Error("No se pudieron cargar los productos");
  }

  return {
    products: productsRes.data.products.filter((p) => Number(p.stock) > 0),
    users: productsRes.data.users || [],
    points: pointsRes.data.points ?? 0,
  };
}

// Un canje puede tomar 4 rutas según tipo de cobro y método de pago.
// Mantiene el payload exacto que cada endpoint del backend ya espera.
const ENDPOINTS = {
  "individual-bravos": "api/store/redeem.php",
  "individual-cash": "api/store/redeem_cash.php",
  "colectivo-bravos": "api/store/collective_charge.php",
  "colectivo-cash": "api/store/collective_charge_cash.php",
};

export async function redeemProduct({
  token,
  userId,
  product,
  quantity,
  chargeType,
  paymentMethod,
  participants,
  size,
  color,
}) {
  const endpoint = ENDPOINTS[`${chargeType}-${paymentMethod}`];
  if (!endpoint) {
    throw new Error("Método de pago no reconocido");
  }

  const unitCost = paymentMethod === "cash" ? product.cash : product.price;
  const totalCost = unitCost * quantity;

  const variant = {
    ...(size ? { size } : {}),
    ...(color ? { color } : {}),
  };

  let payload;
  if (chargeType === "colectivo" && paymentMethod === "bravos") {
    payload = {
      initiator_id: Number(userId),
      product_id: product.id,
      quantity,
      total_cost: totalCost,
      participants,
      ...variant,
    };
  } else if (chargeType === "colectivo" && paymentMethod === "cash") {
    payload = {
      user_id: userId,
      product_id: product.id,
      quantity,
      total_cost: totalCost,
      participants,
      ...variant,
    };
  } else if (paymentMethod === "cash") {
    payload = {
      user_id: userId,
      product_id: product.id,
      quantity,
      total_cost: totalCost,
      payment_method: "cash",
      ...variant,
    };
  } else {
    payload = {
      user_id: userId,
      product_id: product.id,
      quantity,
      ...variant,
    };
  }

  const { data } = await axios.post(`${baseUrl()}/${endpoint}`, payload, {
    headers: authHeaders(token, { "Content-Type": "application/json" }),
  });

  if (!data?.success) {
    throw new Error(data?.message || data?.error || "Error al procesar la solicitud");
  }
  return data;
}

export async function downloadComprobante(file) {
  if (!file) return;
  const res = await fetch(`${baseUrl()}/comprobantes/${file}`);
  if (!res.ok) throw new Error("No se pudo descargar el comprobante");
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = file;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
